import type { Model } from '../../types';

/**
 * The fallback line beside a Model's shutdown date on the Models tab (task
 * 1130). A deprecated or retired Model with a successor names it — the
 * resolver runs on that Model once this one is withdrawn (service task 1129);
 * a deprecated Model with none says "no fallback" in amber, because on its
 * shutdown date every call on it goes to a Model the provider no longer
 * serves. An active Model shows nothing.
 */
export function ModelFallbackNote({ model, catalog }: { model: Model; catalog: Model[] }) {
  if (model.status === 'active') return null;

  if (model.successorModelId) {
    const successor = catalog.find((m) => m.id === model.successorModelId);
    const name = successor ? successor.displayName ?? successor.modelId : model.successorModelId;
    return (
      <span data-testid={`model-fallback-${model.modelId}`} className="block text-xs text-gray-500 dark:text-gray-400">
        falls back to {name}
      </span>
    );
  }

  if (model.status === 'deprecated') {
    return (
      <span data-testid={`model-fallback-${model.modelId}`} className="block text-xs text-amber-700 dark:text-amber-300">
        no fallback
      </span>
    );
  }

  return null;
}
